import { StyledIcon } from 'fitify-ui/src/Icon/Icon.Styled'
import { typographyStyles } from 'fitify-ui/src/typography/generated/Typography'
import { css, styled } from 'styled-components'

import { StyledInputField, StyledInputFieldWrapper } from '../Input.Styled'

const defaultLabelPlaceholder = css`
  top: 1rem;
  ${typographyStyles('Poppins/T4 - Medium')};
  line-height: 1;
`

export const StyledInputWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  flex: 1;
`

export const StyledLabel = styled.label<{ $isDisabled: boolean }>`
  position: absolute;
  top: 50%;
  left: 0;
  color: ${({ $isDisabled, theme }) =>
    $isDisabled
      ? theme.colors['N Content/Disabled']
      : theme.colors['N Content/Secondary']};
  pointer-events: none;
  transform: translateY(-50%);
  transform-origin: left top;
  transition: 0.1s ease-out;
  ${typographyStyles('Poppins/T2 - Medium')};
`

export const StyledInput = styled(StyledInputField)`
  position: absolute;
  bottom: 1.125rem;
  transform: translateY(50%);
  ${typographyStyles('Poppins/T2 - Medium')};

  /* Removes autocomplete background */
  &:is(:-webkit-autofill, :autofill) {
    ${StyledLabel} {
      ${defaultLabelPlaceholder}
    }
  }
`

export const StyledFieldWrapper = styled(StyledInputFieldWrapper)`
  ${StyledIcon} {
    width: 1.5rem;
    height: 1.5rem;
    color: ${({ $hasError, $isDisabled, theme }) => {
      if ($hasError) {
        return theme.colors['N Outline/Error']
      }
      if ($isDisabled) {
        return theme.colors['N Content/Disabled']
      }
      return theme.colors['N Content/Secondary']
    }};
  }

  ${({ $hasValue, $isFocused }) => {
    if ($hasValue || $isFocused) {
      return css`
        ${StyledLabel} {
          ${defaultLabelPlaceholder}
        }
      `
    }
    return null
  }};
`
